const CampaignType = {
  Discount: "discount",
  Voucher: "voucher",
  LOCQPayCampaign: "locqpay-discount",
};

export default CampaignType;
